
export default class ReferenceParser{
	static parse(allReferences){
		let hadReferences = false;
		_.each(allReferences, (references, key)=>{
			_.each(references, (data)=>{
				switch(key){
					case "Player":
						hadReferences = true;
						return Users.update(data);
					case "Ladder":
						hadReferences = true;
						return require('./GameRoom').GameRoom.retrieve(data);
				}
			})
		});
		return hadReferences;
	}
}